// Endpoint: GET ;
import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';
import { toast } from 'sonner';
const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const getLandscapes = async () => {
    try {
        const url = `${BASE_URL}/landscape`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getgreenpillLeaderboard = async (page, entriesPerPage = 10) => {
    try {
        // const url = `${BASE_URL}/landscape/leaderboard?${
        //   collectionNo ? `nftCollectionNumber=${collectionNo}` : ""
        // }&page=1&entriesPerPage=100`
        const url = `${BASE_URL}/citizen/achievementLeaderboard?page=${page || 1}&entriesPerPage=${entriesPerPage}`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status == 201) {
            return {
                status: response.status,
                data: response?.data,
            };
        }
    } catch (error) {
        return error;
    }
};
// Endpoint: GET /citizen/primaryPill

// Endpoint: PUT /citizen/primaryPill
